import React from 'react';

const Box = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="14"
    viewBox="0 0 24 14"
    fill="none"
  >
    <g filter="url(#filter0_i)">
      <path
        d="M0 6.99991C0 10.8599 3.14099 14 6.99994 14L17.0001 14C20.859 14 24 10.8599 24 6.99991C24 3.14006 20.859 0 17.0001 0L6.99994 0C3.14099 0 0 3.14006 0 6.99991Z"
        fill="var(--DISABLED)"
      />
    </g>
    <path
      d="M10.5 6.9999C10.5 9.14769 8.82117 10.8889 6.75009 10.8889C4.67901 10.8889 3 9.14769 3 6.9999C3 4.85211 4.67901 3.1111 6.75009 3.1111C8.82117 3.1111 10.5 4.85211 10.5 6.9999Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_i"
        x="0"
        y="0"
        width="24"
        height="15"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
    </defs>
  </svg>
);

export default Box;
